import React from "react";
import { DatePickerField } from "../fields/DatePickerField";
import { SerializedStyles } from "@emotion/react";
import { useController, useFormContext } from "react-hook-form";

type Props = {
  disabled?: boolean;
  label?: string;
  helperText?: string;
  showTimeSelect?: boolean;
  placeholder?: string;
  minDate?: Date;
  additionalStyling?: SerializedStyles;
  maxDate?: Date;
  className?: string;
  labelIcon?: React.ReactNode;
  width?: string;
  name: string;
  showMonthYearPicker?: boolean;
};

export const DatePickerInput = ({ name, ...rest }: Props) => {
  const { control, formState, getFieldState } = useFormContext();
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <DatePickerField
      onChange={onChange}
      errorMessage={getFieldState(name as string, formState).error?.message}
      value={value}
      {...rest}
    />
  );
};
